import React from "react";
import ScrollToTop from "./components/ScrollTop";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import CadastroDadosCotas from "./screens/CadastroDadosCotas";
import CadastroDadosPessoais from "./screens/CadastroDadosPessoais";
import Inicio from "./screens/Inicio";
import DisponibilizacaoPeriodos from "./screens/DisponibilizacaoPeriodos";
import createGlobalStyle from "./styles/global";
import Interesses from "./screens/Interesses";
import Login from "./screens/Login";
import Home from "./screens/Home";
import EsqueceuSenha from "./screens/EsqueceuSenha";
import VerifiqueEmail from "./screens/VerifiqueEmail";
import AtivacaoExpirada from "./screens/AtivacaoExpirada";
import NaoEncontrado from "./screens/NaoEncontrado";
import AtivacaoEfetuada from "./screens/AtivacaoEfetuada";
import VerifiqueEmailSenha from "./screens/VerifiqueEmailSenha";
import RedefinirSenha from "./screens/RedefinirSenha";
import SenhaAlterada from "./screens/SenhaAlterada";
import { QueryParamProvider } from "use-query-params";
import { ReactRouter6Adapter } from "use-query-params/adapters/react-router-6";
import { parse, stringify } from "query-string";
import DadosPessoais from "./screens/DadosPessoais";
import GerenciarSolicitacoesReservaScreen from "../src/screens/GerenciarSolicitacoesReservaScreen";

import GerenciarEstado from "./screens/GerenciarEstado";
import Gerenciar from "./screens/Gerenciar";
import GerenciarCidade from "./screens/GerenciarCidade";
import GerenciarEmpreendimento from "./screens/GerenciarEmpreendimento";
import GerenciarApto from "./screens/GerenciarApto";
import GerenciarCotas from "./screens/GerenciarCotas";
import GerenciarPeriodos from "./screens/GerenciarPeriodos";
import TermoDeUso from "./screens/TermoDeUso";
import ContratoLocacao from "./screens/ContratoLocacao";
import PoliticaPrivacidade from "./screens/PoliticaPrivacidade";
import Contato from "./screens/Contato";

import QuemSomos from "./screens/QuemSomos";
import ComoDisponibilizarPeriodo from "./screens/ComoDisponibilizarPeríodo";
import Ajuda from "./screens/Ajuda";

import PosCadastroCotasEmpreendChecados from "./screens/PosCadastroCotasEmpreendChecados";
import PosCadastroCotasEmpreendNaoChecados from "./screens/PosCadastroCotasEmpreendNaoChecados";
import PrimeiraVezPosCadastroPessoais from "./screens/PrimeiraVezPosCadastroPessoais";
import PrimeiraVezCadastroCotas from "./screens/PrimeiraVezCadastroCotas";
import PrimeiraVezPeriodos from "./screens/PrimeiraVezPeriodos";
import PrimeiraVezInteresse from "./screens/PrimeiraVezInteresse";
import GerenciarAlugueis from "./screens/GerenciarAlugueis";
import GerenciarInteressesAlugueis from "./screens/GerenciarInteressesAlugueis";
import GerenciarTrocas from "./screens/GerenciarTrocas";
import GerenciarInteressesTrocas from "./screens/GerenciarInteressesTrocas";
import GerenciarUsuarios from "./screens/GerenciarUsuarios";
import InteressesControle from "./screens/InteressesControle";
import GerenciarPropriedades from "./screens/GerenciarPropriedades";
import GerenciarPeriodosUsuarios from "./screens/GerenciarPeriodosUsuarios";
import ConfirmarPeriodoUsuario from "./screens/ConfirmarPeriodoUsuario";
import AlgoDeuErrado from "./screens/AlgoDeuErrado";
import LinkExpirado from "./screens/LinkExpirado";
import SucessoProcedimento from "./screens/SucessoProcedimento";
import CadastroPropriedade from "./screens/CadastroPropriedade";
import CadastroPropriedadeV2 from "./screens/CadastroPropriedadeV2";
import DetalhesCadastroPropriedade from "./views/cadastroPropriedadeV2/ViewDetalhesCadastroPropriedade";
import CadastroRepresentante from "./screens/CadastroRepresentante";
import AdicionarPeriodos from "./screens/AdicionarPeriodos";
import InclusaoCidadeEstado from "./screens/InclusaoCidadeEstado";
import SemPermissao from "./screens/SemPermissao";
import GerenciarDocumentosProprietarios from "./screens/GerenciarDocumentosProprietarios";
import Representantes from "./screens/Representantes";
import FormularioHospedes from "./screens/FormularioHospedes";
import InfoEmpreendimento from "./screens/InfoEmpreendimento";
import GerenciarReserva from "./screens/GerenciarReserva";
import GerenciarAssinatura from "./screens/GerenciarAssinaturas";
import Dashboard from "./screens/Dashboard";
import DashboardOperacional from "./screens/DashboardOperacional";
import DashboardOperacionalIrregularidades from "./screens/DashboardOperacionalIrregularidades";
import DashboardOperacionalVendaSemAssinatura from "./screens/DashboardOperacionalVendaSemAssinatura";
import DashboardOperacionalCotasSemPeriodos from "./screens/DashboardOperacionalCotasSemPeriodos";
import ListarReservas from "./screens/ListarReservas";
import GerenciarPropriedadeUsuario from "./screens/GerenciarPropriedadeUsuario";
import GerenciarPessoas from "./screens/GerenciarPessoas";
import GerenciarPostagens from "./screens/GerenciarPostagens";
import GerenciarEtiquetas from "./screens/GerenciarEtiquetas";
import Postagem from "./screens/Postagem";
import PagamentoVenda from "./screens/PagamentoVenda";
import CadastroSucesso from "./screens/CadastroSucesso";
import Agradecimentos from "./screens/Agradecimentos";
import ContatoVendaPersonalizada from "./screens/ContatoVendaPersonalizada";
import QueroViajar from "./screens/QueroViajar";
import AgradecimentoViagem from "./screens/AgradecimentoViagem";
import GerenciarCompatibilidades from "./screens/GerenciarCompatibilidades";
import GerenciarModeloCampanhas from "./screens/GerenciarModeloCampanhas";
import Juridico from "./screens/Juridico";

import GerenciarIndicacoesParceiros from "./screens/GerenciarIndicacoesParceiros";
import GerenciarAnuncios from "./screens/GerenciarAnuncios";
import PreferenciaMensagem from "./screens/PreferenciaMensagem";
import GerenciarModeloMensagens from "./screens/GerenciarModeloMensagens";
import GerenciarCaracteristicas from "./screens/GerenciarCaracteristicas";
import GerenciarConfigSistema from "./screens/GerenciarConfigSistema";
import GerenciarConfigSistemaVariaveis from "./screens/GerenciarConfigSistemaVariaveis";
import GerenciarCampanhas from "./screens/GerenciarCampanhas";

import GerenciarCategoriaMensagens from "./screens/GerenciarCategoriaMensagens";
import Marketing from "./screens/Marketing";
import WhatsappProviderHealth from "./screens/WhatsappProviderHealth";
import GerenciarMensagens from "./screens/GerenciarMensagens";
import GerenciarAnuncioVenda from "./screens/GerenciarAnuncioVenda";
import ImportarLeadsPlanilha from "./screens/ImportarLeadsPlanilha";

import GerenciarParceiros from "./screens/GerenciarParceiros";
import GerenciarEtiquetaPessoa from "./screens/GerenciarEtiquetaPessoa";
import GerenciarInteressesProprietarios from "./screens/GerenciarInteressesProprietarios";
import Atendimento from "./screens/Atendimento";

const GlobalStyle = createGlobalStyle;

const element = document.getElementById("root");
const root = createRoot(element!);
root.render(
  <BrowserRouter>
    <QueryParamProvider
      adapter={ReactRouter6Adapter}
      options={{
        searchStringToObject: parse,
        objectToSearchString: stringify,
      }}
    >
      <ScrollToTop />
      <Routes>
        <Route path="inicio" element={<Inicio />} />
        <Route path="/" element={<Home />} />
        <Route path="cadastroPessoais" element={<CadastroDadosPessoais />} />
        <Route path="cadastroSucesso" element={<CadastroSucesso />} />
        <Route path="inclusaoCidadeEstado" element={<InclusaoCidadeEstado />} />
        <Route path="representantes" element={<Representantes />} />
        <Route path="cadastroCotas" element={<CadastroDadosCotas />} />
        <Route path="interesses" element={<Interesses />} />
        <Route path="adicionarPeriodos" element={<AdicionarPeriodos />} />
        <Route path="interessesControle" element={<InteressesControle />} />
        <Route path="login" element={<Login />} />
        <Route path="cadastroPropriedade" element={<CadastroPropriedade />} />
        <Route path="cadastroPropriedade/v2" element={<CadastroPropriedadeV2 />} />
        <Route
          path="cadastroPropriedade/detalhes/:cotaUsuarioId"
          element={<DetalhesCadastroPropriedade />}
        />
        <Route
          path="cadastroPropriedade/:cadastroCotaUsuarioId"
          element={<CadastroPropriedadeV2 />}
        />
        <Route path="marketing" element={<Marketing />} />
        <Route path="marketing/saude-whatsapp" element={<WhatsappProviderHealth />} />
        <Route
          path="importarLeadsPlanilha"
          element={<ImportarLeadsPlanilha />}
        />
        <Route path="gerenciarMensagens" element={<GerenciarMensagens />} />
        <Route path="gerenciarConfigSistema" element={<GerenciarConfigSistema />} />
        <Route
          path="gerenciarConfigSistemaVariaveis"
          element={<GerenciarConfigSistemaVariaveis />}
        />
        <Route
          path="gerenciarCaracteristicas"
          element={<GerenciarCaracteristicas />}
        />
        <Route
          path="cadastroRepresentante"
          element={<CadastroRepresentante />}
        />
        <Route
            path="/gerenciar-solicitacoes-reserva"
            element={<GerenciarSolicitacoesReservaScreen />}
          />
        <Route path="formularioHospedes" element={<FormularioHospedes />} />
        <Route
          path="agradecimentocadastrointeresseviagem"
          element={<AgradecimentoViagem />}
        />
        <Route path="queroviajar" element={<QueroViajar />} />
        <Route path="pagamentoVenda" element={<PagamentoVenda />} />
        <Route
          path="contatovendapersonalizada"
          element={<ContatoVendaPersonalizada />}
        />
        <Route path="agradecimentos" element={<Agradecimentos />} />
        <Route path="juridico" element={<Juridico />} />
        <Route path="EsqueceuSenha" element={<EsqueceuSenha />} />
        <Route path="verifiqueEmail" element={<VerifiqueEmail />} />
        <Route path="ativacaoExpirada" element={<AtivacaoExpirada />} />
        <Route path="naoEncontrado" element={<NaoEncontrado />} />
        <Route path="ativacaoEfetuada" element={<AtivacaoEfetuada />} />
        <Route path="senhaAlterada" element={<SenhaAlterada />} />
        <Route path="verifiqueEmailSenha" element={<VerifiqueEmailSenha />} />
        <Route path="sucessoprocedimento" element={<SucessoProcedimento />} />
        <Route path="redefinirSenha" element={<RedefinirSenha />} />
        <Route path="dadosPessoais" element={<DadosPessoais />} />
        <Route path="gerenciar" element={<Gerenciar />} />
        <Route path="gerenciarEstado" element={<GerenciarEstado />} />
        <Route path="preferenciaMensagem" element={<PreferenciaMensagem />} />
        <Route
          path="gerenciarCategoriaMensagens"
          element={<GerenciarCategoriaMensagens />}
        />
        <Route
          path="gerenciarModeloMensagens"
          element={<GerenciarModeloMensagens />}
        />
        <Route path="gerenciarCampanhas" element={<GerenciarCampanhas />} />

        <Route
          path="GerenciarDocumentosProprietarios"
          element={<GerenciarDocumentosProprietarios />}
        />
        <Route path="gerenciarCidade" element={<GerenciarCidade />} />
        <Route path="termodeuso" element={<TermoDeUso />} />
        <Route path="contratoLocacao" element={<ContratoLocacao />} />
        <Route path="politicaprivacidade" element={<PoliticaPrivacidade />} />
        <Route path="contato" element={<Contato />} />
        <Route path="quemsomos" element={<QuemSomos />} />
        {/* <Route path="cadastur" element={<Cadastur />} /> */}
        <Route path="gerenciaralugueis" element={<GerenciarAlugueis />} />
        <Route path="gerenciarUsuarios" element={<GerenciarUsuarios />} />
        <Route path="algodeuerrado" element={<AlgoDeuErrado />} />
        <Route path="infoEmpreendimento" element={<InfoEmpreendimento />} />
        <Route
          path="confirmarPeriodoUsuario"
          element={<ConfirmarPeriodoUsuario />}
        />
        <Route
          path="gerenciarPropriedades"
          element={<GerenciarPropriedades />}
        />
        <Route
          path="GerenciarPeriodosUsuarios"
          element={<GerenciarPeriodosUsuarios />}
        />
        <Route path="gerenciartrocas" element={<GerenciarTrocas />} />
        <Route
          path="gerenciarinteressesalugueis"
          element={<GerenciarInteressesAlugueis />}
        />
        <Route
          path="gerenciarinteressestrocas"
          element={<GerenciarInteressesTrocas />}
        />
        <Route path="sempermissao" element={<SemPermissao />} />
        <Route path="ajuda" element={<Ajuda />} />
        <Route
          path="comodisponibilizarseuperiodo"
          element={<ComoDisponibilizarPeriodo />}
        />
        <Route
          path="poscadastrocotasempreendchecados"
          element={<PosCadastroCotasEmpreendChecados />}
        />
        <Route
          path="poscadastrocotasempreendnaochecados"
          element={<PosCadastroCotasEmpreendNaoChecados />}
        />
        <Route
          path="primeiravezposcadastropessoais"
          element={<PrimeiraVezPosCadastroPessoais />}
        />
        <Route
          path="primeiravezcadastrocotas"
          element={<PrimeiraVezCadastroCotas />}
        />
        <Route path="primeiravezperiodos" element={<PrimeiraVezPeriodos />} />
        <Route path="primeiravezinteresse" element={<PrimeiraVezInteresse />} />
        <Route
          path="gerenciarEmpreendimento"
          element={<GerenciarEmpreendimento />}
        />
        <Route path="gerenciarApto" element={<GerenciarApto />} />
        <Route path="gerenciarCotas" element={<GerenciarCotas />} />
        <Route path="gerenciarPeriodos" element={<GerenciarPeriodos />} />
        <Route path="linkexpirado" element={<LinkExpirado />} />
        <Route
          path="disponibilizacaoPeriodos"
          element={<DisponibilizacaoPeriodos />}
        />
        <Route path="gerenciarReserva" element={<GerenciarReserva />} />
        <Route path="gerenciarAssinatura" element={<GerenciarAssinatura />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="atendimento" element={<Atendimento />} />
        <Route
          path="dashboardOperacional"
          element={<DashboardOperacional />}
        />
        <Route
          path="dashboardOperacional/ctus-com-problema"
          element={<DashboardOperacionalIrregularidades />}
        />
        <Route
          path="dashboardOperacional/postagens-venda-sem-assinatura"
          element={<DashboardOperacionalVendaSemAssinatura />}
        />
        <Route
          path="dashboardOperacional/cotas-cronograma-fixo-sem-periodos"
          element={<DashboardOperacionalCotasSemPeriodos />}
        />
        <Route path="listarReservas" element={<ListarReservas />} />
        <Route
          path="gerenciarPropriedadeUsuario"
          element={<GerenciarPropriedadeUsuario />}
        />
        <Route path="gerenciarPessoas" element={<GerenciarPessoas />} />
        <Route path="gerenciarPostagens" element={<GerenciarPostagens />} />
        <Route path="gerenciarEtiquetas" element={<GerenciarEtiquetas />} />
        <Route
          path="gerenciarIndicacoesParceiros"
          element={<GerenciarIndicacoesParceiros />}
        />
      
        <Route
          path="gerenciarEtiquetaPessoa"
          element={<GerenciarEtiquetaPessoa />}
        />
        <Route
          path="gerenciarModeloCampanhas"
          element={<GerenciarModeloCampanhas />}
        />
        <Route path="postagem" element={<Postagem />} />
        <Route
          path="gerenciarCompatibilidades"
          element={<GerenciarCompatibilidades />}
        />
        <Route path="gerenciarAnuncios" element={<GerenciarAnuncios />} />
        <Route
          path="gerenciarAnuncioVenda"
          element={<GerenciarAnuncioVenda />}
        />

        <Route path="gerenciarParceiros" element={<GerenciarParceiros />} />

        <Route
          path="gerenciarInteressesProprietarios"
          element={<GerenciarInteressesProprietarios />}
        />
      </Routes>
    </QueryParamProvider>
    <React.StrictMode>
      <GlobalStyle />
    </React.StrictMode>
  </BrowserRouter>
);
